import { render, staticRenderFns } from "./PerformanceDetail.vue?vue&type=template&id=1c0d91a7&scoped=true"
import script from "./PerformanceDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./PerformanceDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PerformanceDetail.vue?vue&type=style&index=0&id=1c0d91a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d91a7",
  null
  
)

export default component.exports